/* globals Knitiv */

export default class {
	/** @type {Knitiv.RootScope} */
	$rootScope;

	/** @type {Knitiv.Scope} */
	$scope;

	/* @ngInject */
	/**
	 *
	 * @param {Knitiv.Scope} $scope
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ITimeoutService} $timeout
	 */
	constructor($scope, $rootScope, $timeout) {
		this.$rootScope = $rootScope;
		this.$scope = $scope;
		this.$timeout = $timeout;

		this.loading = false;
		this.isOpen = false;
		this.widgetId = '';
	}

	/**
	 * @param {Event} event
	 */
	toggle(event) {
		event.stopPropagation();
		this.isOpen = !this.isOpen;
	}

	refreshWorkflows() {
		this.$scope.$broadcast('wf-list:refresh');
	}

	onDataLoaded() {
		this.$timeout(() => {
			this.$rootScope.$emit('gridtsack.refresh-item', {
				widgetId: this.widgetId,
			});
		});
	}

	/**
	 */
	onToggle() {
		let count = 5;
		// eslint-disable-next-line angular/interval-service
		const interval = setInterval(() => {
			if (count <= 0) {
				clearInterval(interval);
			}
			this.$rootScope.$emit('gridtsack.refresh-item', {
				widgetId: this.widgetId,
			});
			count -= 1;
		}, 100);
	}
}
